"use client";

import { useEffect, useRef } from "react";

const VIDEO_SRC = "/videos/site-header-banner.mp4";

export default function HomeBannerVideo() {
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        video.muted = true;
        const playPromise = video.play();
        if (playPromise) {
            playPromise.catch(() => {
                // Autoplay may be blocked until user interaction; keep muted fallback visible.
            });
        }
    }, []);

    return (
        <div className="w-full bg-slate-900">
            <video
                ref={videoRef}
                className="block h-auto w-full max-h-[500px] min-h-[200px] object-cover"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
            >
                <source src={VIDEO_SRC} type="video/mp4" />
            </video>
        </div>
    );
}
